/**
 * <hp-countdown data-end="2026-09-15T23:59:00+03:00" data-hide-on-end="true">
 *
 * Banner üzerindeki geri sayım sayacı.
 * - data-end mağaza saat dilimi offset'i ile geldiği için ziyaretçinin
 *   saat diliminden bağımsız olarak aynı ana kadar sayar.
 * - Süre bittiğinde ya gizlenir ya da "bitti" metnini gösterir.
 * - Sekme arka plandayken timer durur, geri gelince anında güncellenir.
 */
(function () {
  'use strict';

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  class HpCountdown extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.endTime = this.parseEnd(this.getAttribute('data-end'));
      this.hideOnEnd = this.getAttribute('data-hide-on-end') !== 'false';

      this.unitsEl = this.querySelector('[data-countdown-units]');
      this.finishedEl = this.querySelector('[data-countdown-finished]');
      this.titleEl = this.querySelector('.slideshow-countdown__title');
      this.daysEl = this.querySelector('[data-countdown-days]');
      this.hoursEl = this.querySelector('[data-countdown-hours]');
      this.minutesEl = this.querySelector('[data-countdown-minutes]');
      this.secondsEl = this.querySelector('[data-countdown-seconds]');

      if (!this.endTime) {
        // Geçersiz/boş tarih: sayaç hiç gösterilmez, banner olduğu gibi kalır.
        this.hidden = true;
        return;
      }

      this.onVisibilityChange = this.onVisibilityChange.bind(this);
      document.addEventListener('visibilitychange', this.onVisibilityChange);

      this.tick();
      this.start();
    }

    disconnectedCallback() {
      this.stop();
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
    }

    parseEnd(value) {
      if (!value) return null;
      var date = new Date(value);
      if (isNaN(date.getTime())) {
        // Safari bazı biçimleri reddediyor: "2026-09-15T23:59:00+03:00" -> tire/boşluk düzelt
        date = new Date(String(value).replace(/-/g, '/').replace('T', ' ').replace(/([+-]\d{2}):(\d{2})$/, ' $1$2'));
      }
      return isNaN(date.getTime()) ? null : date;
    }

    start() {
      this.stop();
      this.intervalId = window.setInterval(this.tick.bind(this), 1000);
    }

    stop() {
      if (this.intervalId) {
        window.clearInterval(this.intervalId);
        this.intervalId = null;
      }
    }

    onVisibilityChange() {
      if (document.hidden) {
        this.stop();
      } else if (!this.finished) {
        this.tick();
        this.start();
      }
    }

    tick() {
      var remaining = this.endTime.getTime() - Date.now();

      if (remaining <= 0) {
        this.render(0);
        this.handleEnd();
        return;
      }

      this.render(remaining);
    }

    render(remaining) {
      var totalSeconds = Math.floor(remaining / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      // Gün kutusu kapalıysa kalan günler saate eklenir, süre eksik görünmez.
      if (!this.daysEl) {
        hours += days * 24;
      } else {
        this.daysEl.textContent = pad(days);
      }

      if (this.hoursEl) this.hoursEl.textContent = pad(hours);
      if (this.minutesEl) this.minutesEl.textContent = pad(minutes);
      if (this.secondsEl) this.secondsEl.textContent = pad(seconds);
    }

    handleEnd() {
      if (this.finished) return;
      this.finished = true;
      this.stop();

      if (this.hideOnEnd || !this.finishedEl) {
        this.hidden = true;
        return;
      }

      if (this.unitsEl) this.unitsEl.hidden = true;
      if (this.titleEl) this.titleEl.hidden = true;
      this.finishedEl.hidden = false;
    }
  }

  if (!window.customElements.get('hp-countdown')) {
    window.customElements.define('hp-countdown', HpCountdown);
  }
})();
